import React from 'react';
import TablePagination from '@mui/material/TablePagination';

const PhotoManagementPagination = ({
  totalList,
  skip,
  rowsPerPage,
  handleChangeRowsPerPage,
  handleChangePage
}) => {
  return (
    <div className='bg-background sticky top-0 flex justify-end items-center h-12 z-12'>
      <TablePagination
        component='div'
        count={totalList}
        page={skip}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onPageChange={handleChangePage}
      />
    </div>
  );
};

export default PhotoManagementPagination;
